import { ApplicationInsights, SeverityLevel } from '@microsoft/applicationinsights-web';

import { getAppInsightsConnectionString } from '../../../../config';

export { SeverityLevel };

/** Only primitives allowed - forces callers to extract ids instead of logging whole entities. */
export type LogProps = Record<string, string | number | boolean | undefined>;

const connectionString = getAppInsightsConnectionString();

/* eslint-disable no-console */
export const appInsights = connectionString
    ? new ApplicationInsights({ config: {
        connectionString,
        enableAutoRouteTracking: true,
        disableCookiesUsage: true,
    } })
    : undefined;

if (appInsights) {
    appInsights.loadAppInsights();
    appInsights.trackPageView();
}

export const logTrace = (message: string, severity: SeverityLevel = SeverityLevel.Information, properties?: LogProps): void => {
    appInsights?.trackTrace({ message, severityLevel: severity }, properties);
    if (import.meta.env.DEV) {
        console.log(message, properties);
    }
};

const toError = (error: unknown): Error => error instanceof Error ? error : new Error(JSON.stringify(error));

export const logException = (error: unknown, properties?: LogProps): void => {
    appInsights?.trackException({ error: toError(error), severityLevel: SeverityLevel.Error }, properties);
    if (import.meta.env.DEV) {
        console.error(error, properties);
    }
};

export const logSecurityEvent = (name: string, severity: SeverityLevel, properties?: LogProps): void => {
    appInsights?.trackEvent({ name }, { ...properties, severityLevel: SeverityLevel[severity] });
    if (import.meta.env.DEV) {
        console.warn(name, SeverityLevel[severity], properties);
    }
};
/* eslint-enable no-console */
